import React from 'react';

import { Heading } from '../Heading/Heading';

import { SEOSpeciesLink } from './components/SEOSpeciesLink';
import { SEOWaterLink } from './components/SEOWaterLink';
import { ISEOWaterObjWithName } from '../../constants/fishingWaters/constants';

interface IProps {
  topSearchedWaters: ISEOWaterObjWithName[];
}

export const SEOLinksFooter = ({ topSearchedWaters }: IProps) => {
  return (
    <div className="bg-lake-fog">
      <div className="max-w-[1200px] md:mx-auto">
        <div className="mx-6 py-4 sm:mx-12 sm:py-8">
          <Heading as="h4" variant="xs" className="mb-4">
            Explore some of the most popularly fished species across our app
          </Heading>
          <SEOSpeciesLink />
          <Heading as="h3" variant="xs" className="mb-4">
            Check out popular fishing waters in the US
          </Heading>
          <SEOWaterLink topSearchedWaters={topSearchedWaters} />
        </div>
      </div>
    </div>
  );
};
